import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import Screen from 'components/Screen';
import { useAppSubdomain } from 'hooks/useAppSubdomain';
import { txt } from 'libs/i18n';
import beeImage from '404/bee.svg';
import styles from './style.module.less';
const NotFoundScreen = () => {
    const { pageTitle } = useAppSubdomain(txt('notFound'));
    return (_jsxs(Screen, { children: [_jsx(Helmet, { title: pageTitle }), _jsxs("div", { className: styles.notFound, children: [_jsxs("div", { className: styles.code, children: ["404", _jsx("img", { className: styles.bee, src: beeImage, alt: "" })] }), _jsx("p", { className: styles.heading, children: txt('wrongHive') }), _jsx("p", { className: styles.description, children: txt('pageNotFound') }), _jsx(Link, { className: styles.link, to: "/projects", children: txt('returnToBeey') })] })] }));
};
export default NotFoundScreen;
